import { useEffect, useRef } from 'react';

function usePrevious<T>(value: T | undefined): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}

export default usePrevious;
